import { ref, computed } from 'vue';

export default function useScroll(options = {}) {
    const scrollTop = ref(0);
    const { shadowClass = 'shadow-scroll-inset' } = options;

    const handleScroll = (e) => {
        scrollTop.value = e.target.scrollTop;
    };

    const scrollClasses = computed(() => ({
        [shadowClass]: scrollTop.value > 0
    }));

    return {
        scrollTop,
        handleScroll,
        scrollClasses
    };
} 